import React from 'react';

import SelectionList from '../../selectionList/SelectionList';

import { getCurrentResource } from '../../../util/tools';
import {findConditionIndex} from './util';

import {
	CONDITION_NONE,
	CONDITION_EACH_CASE,
	CONDITION_AT_LEAST_ONE_CASE,
} from './util';

class FilterBooleanGroup extends React.Component {
	
	cbList = [];
	filterModel = null;
	realm = null;
	listCbFields = [];
	
	/*
		props:
			filter
			filterIndex
			holder
			rateView
			handleFilterChanged
	*/
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.conditions.FilterBooleanGroup;
		props.holder.registerFilterComponent(this, props.filterIndex);
		let filter = props.filter;

		this.refConditionList = React.createRef();
		this.resCondition = getCurrentResource().components.rateview.conditions.conditions; 
		this.conditions = [
			{id: CONDITION_NONE, title: this.resCondition.none.title},
		];
		for(let conditionId of filter.filterModel.listConditions) {
			this.conditions.push(
				{id: conditionId, title: this.resCondition[conditionId].title}
			);
		}
		let conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		
		this.filterModel = props.filter.filterModel;
		this.realm = props.rateView.realm;
		let instanceModel = this.realm.getInstanceModel(this.filterModel.classId);
		this.listCbFields = [];
		for(let field of instanceModel.subfields) {
			if( field.virtualGroupName == this.filterModel.virtualGroupName ) {
				this.listCbFields.push( field );
			}
		}
		
		this.state = {
			filter: filter,
			conditionIndex: conditionIndex,
		}
	}
	updateFilter = (filter) => {
		let conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		this.refConditionList.current.setSelectedIndex( conditionIndex );
		this.setState({filter: filter, conditionIndex: conditionIndex});
	}

	handleConditionSelection = (index) => {
		if( index == -1 )
			index = 0;
		let cond = this.conditions[index];
		this.props.filter.conditionId = cond.id;
		this.setState({conditionIndex: index}, this.handleFilterChanged);
	}	

	handleValueChange = (e) => {
		const {name, checked} = e.target;
		let filter = this.props.filter;
		let idx = filter.listValue.indexOf( name )
		if( checked ) {
			if( idx < 0 )
				filter.listValue.push(name)
		} else { 
			if ( idx >= 0 ) {
				filter.listValue.splice(idx, 1);
			}
		}

		this.handleFilterChanged( filter );
		this.setState({filter: filter})
	}

	handleFilterChanged = (filter) => {
		if( ! filter )
			filter = this.props.filter;

		if( filter.conditionId == CONDITION_NONE ) {
			filter.active = false;
			filter.bodyText = '';
		} else {
			if( filter.listValue.length == 0 ) {
				filter.active = false;
				filter.bodyText = '';
			} else {
				filter.active = true;
				filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title + ' (';
				let first = true;
				for(let fld of this.listCbFields) {
					if( filter.listValue.includes(fld.fieldId) ) {
						if( first )
							first = false;
						else
							filter.bodyText += ", ";
						if( filter.listValue.includes(fld.fieldId) ) {
							filter.bodyText += "'" + fld.title + "'";
						}
					}
				}
				filter.bodyText += ")";
			}
		}

		this.props.handleFilterChanged( filter );
	}

	render() {
		return (
			<div style={{display: 'flex'}}>
				<div style={{width: '250px', border: '1px solid black'}}>
					<SelectionList 
						ref={this.refConditionList}
						items={this.conditions} 
						handleItemSelection={this.handleConditionSelection}
						selectedIndex={this.state.conditionIndex} 
					/>
				</div>
				<div style={{flexGrow: '100', marginLeft: '10px'}}>
					<FilterValue holder={this} />
				</div>
			</div>
		);
	}
}

function FilterValue(props) {
	let holder = props.holder;
	let cond = holder.conditions[ holder.state.conditionIndex ];
	if( cond.id == CONDITION_NONE ) {
		return null;
	} else {
		let filter = holder.props.filter;
		let listCbHtml = holder.listCbFields.map( (field, index) => {
			let checked = filter.listValue.includes( field.fieldId );
			return (
				<div key={index}>
					<input type='checkbox' name={field.fieldId} onChange={holder.handleValueChange} checked={checked} />
					<span style={{marginLeft: '10px'}}>{field.title}</span>
				</div>
			)
		} );
		return (
			<div>
			{listCbHtml}
			</div>
		); 
	}
}

export default FilterBooleanGroup;

